import { defineMessages } from 'react-intl'

const messages = defineMessages({
  sizeGuide: {
    id: 'Sizechart.sizeGuide',
    defaultMessage: 'Storleksguide',
  },
  women: {
    id: 'Sizechart.women',
    defaultMessage: 'Kvinnor',
  },
  men: {
    id: 'Sizechart.men',
    defaultMessage: 'Män',
  },
  toddler: {
    id: 'Sizechart.toddler',
    defaultMessage: 'Litet barn - 1-5 År',
  },
  infant: {
    id: 'Sizechart.infant',
    defaultMessage: 'Spädbarn - 0-12 Månader',
  },
  kids: {
    id: 'Sizechart.kids',
    defaultMessage: 'Barn - 6-10 År',
  },
})

export default messages
